import { useMemo, useState } from 'react'
import { t, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'

import RadioGroupInput from '@/components/ui/inputs/RadioGroupInput'

import { useCreateShiftException } from '../model/useCreateShiftException'
import { useDeleteShiftTemplate } from '../model/useDeleteShiftTemplate'

type DeleteShiftTemplateDialogProps = {
  onClose?: () => void
  open: boolean
  planningId: string
  shiftTemplateId: string
  startTime: string
  endTime: string
}

export function DeleteShiftTemplateDialog({ onClose, open, planningId, shiftTemplateId, startTime, endTime }: DeleteShiftTemplateDialogProps) {
  useLingui()

  const [creatShiftException, isCreatingShiftException] = useCreateShiftException()
  const [deleteShiftTemplate, isDeletingShiftTemplate] = useDeleteShiftTemplate()

  const [selectedDeleteType, setSelectedDeleteType] = useState('one')

  const options = useMemo(
    () => [
      { label: t`This shift`, value: 'one' },
      { label: t`All shifts`, value: 'all' },
    ],
    []
  )

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle>
        <Trans>Delete Shift</Trans>
      </DialogTitle>
      <DialogContent>
        <RadioGroupInput
          onChange={(_event, value) => {
            setSelectedDeleteType(value)
          }}
          options={options}
          value={selectedDeleteType}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          <Trans>Cancel</Trans>
        </Button>
        <LoadingButton
          color="error"
          loading={isCreatingShiftException || isDeletingShiftTemplate}
          onClick={async () => {
            switch (selectedDeleteType) {
              case 'one':
                await creatShiftException({ planningId, shiftTemplate: shiftTemplateId, startTime, endTime })
                break
              case 'all':
                await deleteShiftTemplate(planningId, shiftTemplateId)
                break
            }
            onClose?.()
          }}
          variant="outlined"
        >
          <Trans>Delete</Trans>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
